import { DAWN_AT, NIGHT_END, NIGHT_START } from '../../shared/palette';
import { setFraction } from '../lineup';
import type { StepContext } from '../systems/types';

export function hourOf({ set, state }: Pick<StepContext, 'set' | 'state'>): number {
  return setFraction(set, state);
}

export function nightLit(extra: number, hour: number): number {
  if (hour < NIGHT_START) {
    return 0;
  }
  if (hour < NIGHT_END) {
    return extra;
  }
  return Math.max(0, Math.ceil((extra * (DAWN_AT - hour)) / (DAWN_AT - NIGHT_END)));
}
